import React, { Component } from 'react';
import StarRatingComponent from 'react-star-rating-component';

import './Settings.css';
import './SelfSideBar.css';

import AuthService from './AuthService';
import whitebox from './assets/White_square.png';
import {
  Link,
} from 'react-router-dom';
import constants from '../config';


const Auth = new AuthService();

class SelfSideBar extends Component {
  constructor() {
    super();
    this.state = {
      id: '',
      posts: [],
      name: '',
      username: '',
      bio: '',
      profilePic: whitebox,
      backgroundPicture: whitebox,
      following: [],
      followers: [],
      rating: 0,
      reviews: [],
    };
    this.profile = this.profile.bind(this);
  }
  componentWillMount() {

  }
  componentDidMount() {
    this.profile(this.props.user.userName);
  }
  componentWillReceiveProps(nextProps) {
    this.profile(nextProps.user.userName);
    this.setState({
      profilePic: nextProps.profilePic,
      backgroundPicture: nextProps.backgroundPicture,
      name: nextProps.name,
      username: nextProps.username,
    });
  }


  profile(username) {
    Auth.fetch(`${constants.DOMAIN}/api/v1/guest/meta/${username}`, {
      mode: 'cors',
      method: 'GET',
    }).then(res => {
      console.log('selfsidebar', res);
      this.setState({
        id: res.profile._id,
        posts: res.sortedProfile,
        name: res.profile.name,
        username: res.profile.userName,
        displayUsername: '@' + res.profile.userName,
        bio: res.profile.bio,
        profilePic: `${constants.DOMAIN}/` + res.profile.image,
        backgroundPicture: `${constants.DOMAIN}/` + res.profile.backgroundPicture,
        following: res.profile.isFollowing,
        followers: res.profile.followers,
        rating: res.profile.rating,
        reviews: res.reviews,
      });
    })
      .catch(err => {
        console.log(err);
      });
  }


  render() {
    return (
      <div className="col-md-3 self-profile">
        <img id="backgroundPicture" src={this.state.backgroundPicture} alt="backgroundPicture" />
        <Link to={`/shop/${String(this.state.username)}`}>
          <img id="profilePicture" alt="profilePicture" src={this.state.profilePic}/>

          <h3>{this.state.name}</h3>
          <p style={{ color: '#2155cf' }} id='username'>{this.state.displayUsername}</p>
        </Link>
        <div className="stars">
          <Link to={`/reviews/${this.state.id}`}>
            <StarRatingComponent
              name="sideBarRating"
              starCount={5}
              starColor="#ffd788"
              emptyStarColor="#939393"
              value={this.state.rating}
            />
          </Link>
        </div>

        <div className="col-md-4 col-sm-4 SelfProps">
          <Link to={`/shop/${String(this.state.username)}`}>
            <p>Post</p>
            <strong>{this.state.posts.length}</strong>
          </Link>
        </div>
        <div className="col-md-4 col-sm-4 SelfProps">
          <Link to={`/following/${this.state.username}`}>
            <p>Following</p>
            <strong>{this.state.following.length}</strong>
          </Link>
        </div>
        <div className="col-md-4 col-sm-4 SelfProps">
          <Link to={`/followers/${this.state.username}`}>
            <p>Followers</p>
            <strong>{this.state.followers.length}</strong>
          </Link>
        </div>
      </div>
    );
  }
}

export default SelfSideBar;
